// store/slices/snackbar.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    queue: [],
    currentSnackbar: null
};

const queuesnackbar = createSlice({
    name: 'queuesnackbar',
    initialState,
    reducers: {
        enqueueSnackbar: (state, action) => {
            state.queue.push(action.payload);
            if (!state.currentSnackbar) {
                state.currentSnackbar = state.queue.shift();
            }
        },
        closeQueueSnackbar: (state) => {
            state.currentSnackbar = null;
            if (state.queue.length > 0) {
                state.currentSnackbar = state.queue.shift();
            }
        }
    }
});

export const { enqueueSnackbar, closeQueueSnackbar } = queuesnackbar.actions;

export default queuesnackbar.reducer;
